import React from "react";

const CtaOptions = ({ params, ...rest }) => {
  
  // console.log(storePermission, "store_permission");
  // console.log(value["customer_type"], "value");
  const { data } = params;
  let menuItems = [];

  if (data["product_key"] === "49F37046FCD84520895FC18A4F5BFC8B") {
    if (rest.storePermission == 1) {
      if (data["customer_type"] === "customer") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModalMuviClassic(
                `Are you sure to login this store '${data.company_name}'?`,
                data
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
            </li>,
              <li
              className="list-group-item"
              data-toggle="modal"
              data-target="#confirmModal"
         
              data-keyboard="false"
              data-backdrop="static"
              onClick={() => rest.manageMuviOwnerShipHandler(data)}
            >
              Manage Muvi Ownership
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#changePassword"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickChangePasswordModal(data)}
          >
            Change Password
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#cancelAccount"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickCancelAccountModal(data)}
          >
            Cancel Account
          </li>
        );
      } else if (data["customer_type"] === "demo") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModalMuviClassic(
                `Are you sure to login this store '${data.company_name}'?`,
                data
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
            </li>,
              <li
              className="list-group-item"
              data-toggle="modal"
              data-target="#confirmModal"
         
              data-keyboard="false"
              data-backdrop="static"
              onClick={() => rest.manageMuviOwnerShipHandler(data)}
            >
              Manage Muvi Ownership
          </li>,

          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#manageDemoAccountClassicModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() =>
              rest.handleConfirmManageDemoMuvi5(
                `Are you sure you want to remove '${data.company_name}' account to demo studio?`,
                data.product_key,
                data.customer_id,
                false
              )
            }
          >
            Remove From Demo
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#cancelAccount"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickCancelAccountModal(data)}
          >
            Cancel Account
          </li>
        );
      } else if (data["customer_type"] === "lead") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModalMuviClassic(
                `Are you sure to login this store '${data.company_name}'?`,
                data
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
            </li>,
           <li
           className="list-group-item"
           data-toggle="modal"
           data-target="#confirmModal"
      
           data-keyboard="false"
           data-backdrop="static"
           onClick={() => rest.manageMuviOwnerShipHandler(data)}
         >
           Manage Muvi Ownership
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#changePassword"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickChangePasswordModal(data)}
          >
            Change Password
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#manageDemoAccountClassicModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() =>
              rest.handleConfirmManageDemoMuvi5(
                `Are you sure you want to move '${data.company_name}' account to demo studio?`,
                data.product_key,
                data.customer_id,
                true
              )
            }
          >
            Move to Demo
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#cancelAccount"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickCancelAccountModal(data)}
          >
            Cancel Account
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#extendedTrailPeriodModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickExtendTrialPeriodModal(data)}
          >
            Extend Free Trail
          </li>
        );
      } else if (data["customer_type"] === "cancelled") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModalMuviClassic(
                `Are you sure to login this store '${data.company_name}'?`,
                data
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account Check
            </li>,
              <li
              className="list-group-item"
              data-toggle="modal"
              data-target="#confirmModal"
         
              data-keyboard="false"
              data-backdrop="static"
              onClick={() => rest.manageMuviOwnerShipHandler(data)}
            >
              Manage Muvi Ownership
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#restoreModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickRestoreModal(data)}
          >
            Restore
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#deleteModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() =>
              rest.handleClickDeleteModal(
                `Are you sure you want to delete account '${data.company_name}'?`,
                data.product_key,
                data.customer_id,
                data.customer_user_uuid
              )
            }
          >
            Delete
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#subscriptionModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.handleClickSubscriptionModal(data)}
          >
            Subscription Link
          </li>
        );
      } else {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModalMuviClassic(
                `Are you sure to login this store '${data.company_name}'?`,
                data
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
          </li>
        );
      }
    } else {
      menuItems.push(
        <li
          className="list-group-item"
          data-toggle="modal"
          data-target="#confirmModal"
          onClick={() =>
            rest.handleClickConfirmModalMuviClassic(
              `Are you sure to login this store '${data.company_name}'?`,
              data
            )
          }
          data-keyboard="false"
          data-backdrop="static"
        >
          Login To Account
        </li>
      );
    }
  } else {
    // Muvi 6
    if (rest.storePermission == 1) {
      if (data["customer_type"] === "customer") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModal(
                `Are you sure to login this store '${data.company_name}'?`,
                data.product_key,
                data.customer_user_uuid,
                data.customer_id
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
          </li>,
            <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
       
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.manageMuviOwnerShipHandler(data)}
          >
            Manage Muvi Ownership
          </li>,
          // <li
          // 	className="list-group-item"
          // 	data-toggle="modal"
          // 	data-target="#raiseCustomInvoice"
          // 	data-keyboard="false"
          // 	data-backdrop="static"
          // 	onClick={() => handleClickRaiseCustomInvoiceModal(value)}
          // >
          // 	Raise Custom Invoice
          // </li>
        );
      } else if (data["customer_type"] === "lead") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModal(
                `Are you sure to login this store '${data.company_name}'?`,
                data.product_key,
                data.customer_user_uuid,
                data.customer_id
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
            </li>,
          <li
          className="list-group-item"
          data-toggle="modal"
          data-target="#confirmModal"
     
          data-keyboard="false"
          data-backdrop="static"
          onClick={() => rest.manageMuviOwnerShipHandler(data)}
        >
          Manage Muvi Ownership
          </li>,

          <li
            class="list-group-item"
            manageDemoAccountModal
            data-toggle="modal"
            data-target="#manageDemoAccountModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() =>
              rest.handleConfirmToManageDemoAccount(
                `Are you sure you want to move '${data.company_name}' account to demo studio?`,
                data.product_key,
                data.customer_user_uuid,
                data.customer_id,
                data.store_key,
                true
              )
            }
          >
            Move to demo
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#extendFreeTrial"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() => rest.extendFreeTrialHandler(data)}
          >
            Extend Free Trial
          </li>
          // <li
          // 	class="list-group-item"
          // 	data-toggle="modal"
          // 	data-target="#raiseCustomInvoice"
          // 	data-keyboard="false"
          // 	data-backdrop="static"
          // 	onClick={() => handleClickRaiseCustomInvoiceModal(value)}
          // >
          // 	Raise custom Invoice
          // </li>
        );
      } else if (data["customer_type"] === "demo") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModal(
                `Are you sure to login this store '${data.company_name}'?`,
                data.product_key,
                data.customer_user_uuid,
                data.customer_id
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
            </li>,
              <li
              className="list-group-item"
              data-toggle="modal"
              data-target="#confirmModal"
         
              data-keyboard="false"
              data-backdrop="static"
              onClick={() => rest.manageMuviOwnerShipHandler(data)}
            >
              Manage Muvi Ownership
          </li>,
          <li
            class="list-group-item"
            data-toggle="modal"
            data-target="#manageDemoAccountModal"
            data-keyboard="false"
            data-backdrop="static"
            onClick={() =>
              rest.handleConfirmToManageDemoAccount(
                `Are you sure you want to remove '${data.company_name}' account to demo studio?`,
                data.product_key,
                data.customer_user_uuid,
                data.customer_id,
                data.store_key,
                false
              )
            }
          >
            Remove From Demo
          </li>
        );
      } else if (data["customer_type"] === "cancelled") {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModal(
                `Are you sure to login this store '${data.company_name}'?`,
                data.product_key,
                data.customer_user_uuid,
                data.customer_id
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
          </li>,
           <li
           className="list-group-item"
           data-toggle="modal"
           data-target="#confirmModal"
      
           data-keyboard="false"
           data-backdrop="static"
           onClick={() => rest.manageMuviOwnerShipHandler(data)}
         >
           Manage Muvi Ownership
         </li>,
        );
      } else {
        menuItems.push(
          <li
            className="list-group-item"
            data-toggle="modal"
            data-target="#confirmModal"
            onClick={() =>
              rest.handleClickConfirmModal(
                `Are you sure to login this store '${data.company_name}'?`,
                data.product_key,
                data.customer_user_uuid,
                data.customer_id
              )
            }
            data-keyboard="false"
            data-backdrop="static"
          >
            Login To Account
          </li>
        );
      }
    } else {
      menuItems.push(
        <li
          className="list-group-item"
          data-toggle="modal"
          data-target="#confirmModal"
          onClick={() =>
            rest.handleClickConfirmModal(
              `Are you sure to login this store '${data.company_name}'?`,
              data.product_key,
              data.customer_user_uuid,
              data.customer_id
            )
          }
          data-keyboard="false"
          data-backdrop="static"
        >
          Login To Account
        </li>
      );
    }
  }
  
  return (
    <ul class="list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">
      {menuItems.map((menuItem, index) => (
        <span key={index}>{menuItem}</span>
      ))}
    </ul>
  );
};

export default CtaOptions;



// WEBPACK FOOTER //
// ./src/components/crm/customer/CtaOptions.js